'use client';

import { SIZE } from '@constants';
import { Row } from '@viewup/ui';
import { EventLogoSlot } from './EventLogoSlot';
import { HeaderNotification } from './HeaderNotification';
import { HeaderPoint } from './HeaderPoint';

export const Header = () => {
  return (
    <Row alignItems='center' height={SIZE.HEADER_HEIGHT} justifyContent='space-between' px={16}>
      <EventLogoSlot />

      <Row alignItems='center' gap={16} height={'100%'}>
        <HeaderPoint />
        <HeaderNotification />
      </Row>
    </Row>
  );
};
